<div class="row">
  <div class="col-md-4"></div>
  <div class="col-md-12 mx-auto mt-2">
    <ng-template [ngIf]="
        confirmBookingFormType === 'pre-booking-form' ||
        confirmBookingFormType === 'post-booking-requote-ticket-form' ||
        confirmBookingFormType === 'post-booking-paid-sale-seat-form' ||
        confirmBookingFormType === 'post-booking-reshop'
      ">
      <h3>Confirm Booking</h3>
    </ng-template>
    <ng-template [ngIf]="confirmBookingFormType === 'post-booking-issue-ticket-form'">
      <h5 class="mt-4">Issue Tickets Total</h5>
    </ng-template>
    <ng-template [ngIf]="confirmBookingFormType === 'post-booking-add-paid-ancilliaries-service'">
      <h5 class="mt-4">Confirm Services</h5>
    </ng-template>

    <div class="paypn commonFormsCss">
      <div *ngIf="submitted && !paymentForm.valid" class="errFm smx red mb-10"><i class="fa fa-times fa-lg"></i>Error :
        Not all details provided. Please complete form</div>
      <form [formGroup]="paymentForm" (submit)="saveBooking()">
        <ng-template [ngIf]="
            confirmBookingFormType === 'post-booking-add-paid-ancilliaries-service' ||
            confirmBookingFormType === 'pre-booking-form' ||
            confirmBookingFormType === 'post-booking-issue-ticket-form' ||
            confirmBookingFormType === 'post-booking-paid-sale-seat-form' ||
            confirmBookingFormType === 'post-booking-reshop'
          ">
          <div class="row">
            <div class="col-sm-8">
              <div class="radio-toolbar">
                <input type="radio" value="CASH" />
                <label for="paycash" [class.active-payment-type-btn]="inp_group('paymentType').value === 'CASH'"
                  (click)="upPaymentType('CASH')">Cash</label>
                <ng-template [ngIf]="!isCardPaymentNotAllowed">
                  <input type="radio" value="CARD" />
                  <label for="paycc" [class.active-payment-type-btn]="inp_group('paymentType').value === 'CARD'"
                    (click)="upPaymentType('CARD')">Credit Card</label>
                </ng-template>
                <ng-template [ngIf]="confirmBookingFormType === 'pre-booking-form'">
                  <input type="radio" value="HOLD" />
                  <label for="payhold" [class.active-payment-type-btn]="inp_group('paymentType').value === 'HOLD'"
                    (click)="upPaymentType('HOLD')">Hold</label>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-4 col-lg-4 col-sm-4">
              <div class="customer-detail" formGroupName="customerDetail"
                *ngIf="inp_group('paymentType').value === 'CARD'">
                <h4>Payer</h4>
                <ng-template [ngIf]="!inp_group_control('customerDetail', 'customerType').value">
                  <div class="form-group">
                    <input type="text" placeholder="First Name" class="form-control" formControlName="firstName"
                      [ngClass]="{
                        'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('customerDetail.firstName').invalid,
                        'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('customerDetail.firstName').valid
                      }" />
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="Last Name" class="form-control" formControlName="lastName"
                      [ngClass]="{
                        'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('customerDetail.lastName').invalid,
                        'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('customerDetail.lastName').valid
                      }" />
                  </div>
                </ng-template>
                <ng-template [ngIf]="inp_group_control('customerDetail', 'customerType').value">
                  <div class="form-group">
                    <select class="form-control" formControlName="user">
                      <option *ngFor="let passenger of passengerDropDownList; let passengerIndex = index"
                        value="{{ passengerIndex }}">{{ passenger.text }}</option>
                    </select>
                  </div>
                </ng-template>
                <div class="col-12 mb-3 wrapToggle pr-0">
                  <ng-toggle class="float-right" onColor="{{ model1.onColor }}" onText="{{ model1.onText }}"
                    offColor="{{ model1.offColor }}" (valueChange)="onCustomerValueChange($event)"
                    offText="{{ model1.offText }}" [size]="model1.size" formControlName="customerType">
                  </ng-toggle>
                  <!-- <button type="button" class="btn btn-outline-primary btn-md pull-right" (click)="onPlayerClick()">Payer</button> -->
                </div>
                <div class="clearfix"></div>
                <h5>ADDRESS</h5>
                <div class="form-group">
                  <input type="text" placeholder="Address1" class="form-control" formControlName="address1" [ngClass]="{
                      'is-invalid': submitted && paymentForm.get('customerDetail.address1').invalid
                    }" />
                </div>
                <div class="form-group">
                  <input type="text" placeholder="Address2" class="form-control" formControlName="address2" />
                </div>
                <div class="form-group">
                  <input type="text" placeholder="City" class="form-control" formControlName="city" [ngClass]="{
                      'is-invalid': submitted && paymentForm.get('customerDetail.city').invalid
                    }" />
                </div>
                <div class="row">
                  <div class="form-group col-md-8">
                    <input type="text" placeholder="State" class="form-control" formControlName="state" />
                  </div>
                  <div class="form-group col-md-4">
                    <input type="text" placeholder="Zipcode" class="form-control" formControlName="zipCode" [ngClass]="{
                        'is-invalid': submitted && paymentForm.get('customerDetail.zipCode').invalid
                      }" />
                  </div>
                </div>

                <div class="form-group">
                  <select class="form-control form-select" formControlName="country" [ngClass]="{
                      'is-invalid': submitted && paymentForm.get('customerDetail.country').value === '0'
                    }">
                    <option [value]="0">(please select a country)</option>
                    <option *ngFor="let nation of countries" [value]="nation.name">{{ nation.name }}</option>
                  </select>
                  <span class="text-danger" *ngIf="
                      paymentForm.get('customerDetail.country').invalid &&
                      (paymentForm.get('customerDetail.country').dirty || paymentForm.get('customerDetail.country').touched || paymentForm.submitted) &&
                      paymentForm.get('country').errors?.required
                    ">Please Select Country</span>
                </div>
              </div>
              <div class="customer-detail" formGroupName="contactDetails">
                <div class="form-group">
                  <input type="email" placeholder="Email" class="form-control" formControlName="email" [ngClass]="{
                      'is-invalid': submitted && paymentForm.get('contactDetails.email').invalid
                    }" />
                </div>
                <div class="form-group">
                  <!-- <input type="text" placeholder="Phone" class="form-control"
                                          formControlName="phone"> -->
                  <ngx-intl-tel-input [cssClass]="'custom form-control'" [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedKingdom" [maxLength]="15"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" formControlName="phone">
                  </ngx-intl-tel-input>
                  <div class="text-danger" *ngIf="submitted && paymentForm.get('contactDetails.phone').invalid">Invalid
                    Phonenumber</div>
                </div>
              </div>
            </div>

            <div class="col-md-8 col-lg-8 col-sm-8">
              <div class="row">
                <div class="col-md-12 col-lg-4 col-sm-12"
                  *ngIf="inp_group('paymentType').value === 'CARD' || isCardPaymentNotAllowed">
                  <h4>Card Details</h4>
                  <div class="customer-detail" *ngIf="!isCardPaymentNotAllowed" formGroupName="cardDetail">
                    <div class="form-group">
                      <select (change)="getCardsNumbers()" formControlName="cardType" class="form-control mb-16"
                        #cardType (change)="getCardNumbers(cardType.value)" [ngClass]="{
                          'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cardType').invalid,

                          'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cardType').valid
                        }">
                        <option value="" selected disabled>Select Card Type</option>
                        <ng-container *ngFor="let cardDetail of availableCards; let i = index">
                          <option [value]="i">{{ cardDetail.name }}({{ cardDetail.surcharge }})</option>
                        </ng-container>
                      </select>
                    </div>
                    <!-- <div class="form-group"><input type="text" placeholder="Card Number" class="form-control" formControlName="cardNumber" /></div> -->
                    <div class="form-group">
                      <select (change)="storeSelectedCardDetail()" formControlName="cardNumber"
                        class="form-control mb-16" #cardType (change)="getCardNumbers(cardType.value)" [ngClass]="{
                          'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cardNumber').invalid,

                          'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cardNumber').valid
                        }">
                        <option value="" selected disabled>Select Card Number</option>
                        <ng-container *ngFor="let cardnumberDetail of cardNumberDetails">
                          <option [value]="cardnumberDetail.cardNumber">{{ cardnumberDetail.cardNumber }}</option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group">
                          <input type="text" placeholder="MM" class="form-control mb-16" formControlName="validMM"
                            [ngClass]="{
                              'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.validMM').invalid,
                              'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.validMM').valid
                            }" />
                        </div>
                      </div>
                      <div class="col-sm-6 pl-0">
                        <div class="form-group">
                          <input type="text" placeholder="YY" class="form-control" formControlName="validYY" [ngClass]="{
                              'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.validYY').invalid,
                              'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.validYY').valid
                            }" />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div class="row flexAside">
                          <div class="col-6">
                            <div class="form-group">
                              <input type="text" placeholder="CV2" class="form-control" formControlName="cv" [ngClass]="{
                                  'is-invalid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cv').invalid,
                                  'is-valid': submitted && inp_group('paymentType').value === 'CARD' && paymentForm.get('cardDetail.cv').valid
                                }" />
                            </div>
                          </div>

                          <div class="col-4 wrapToggle two">
                            <ng-toggle class="float-right" onColor="{{ model2.onColor }}" onText="{{ model2.onText }}"
                              offColor="{{ model2.offColor }}" offText="{{ model2.offText }}" [size]="model2.size"
                              formControlName="paymentMode">
                            </ng-toggle>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isCardPaymentNotAllowed"><i class="fa fa-exclamation-triangle"></i> Card payment not
                    permitted - Only Cash Accepted</div>
                </div>

                <div class="col-md-12 col-lg-8 col-sm-12">
                  <div class="customer-detail" formGroupName="voucherDetail">
                    <ng-template [ngIf]="confirmBookingFormType === 'pre-booking-form'">
                      <h4 class="hideContent">Voucher</h4>
                      <div class="row hideContent">
                        <div class="form-group col-md-6">
                          <input type="text" placeholder="eVoucher #" class="form-control"
                            formControlName="voucherCode" />
                        </div>
                        <div class="form-group col-md-4 col-md-6">
                          <button class="btn btn-outline-primary ba-btn float-right" role="button" type="button"><i
                              class="fa fa-ticket-alt"></i>Add Voucher</button>
                        </div>
                      </div>
                    </ng-template>
                    <div class="pnfin">
                      <h4>Total Due</h4>

                      <div class="row">
                        <div class="col-sm-4">Flights</div>
                        <div class="col-sm-7 txtRt pr-2">{{ roundConfirmBookingPrice(priceDetails.flightCharge) }}</div>
                        <div class="col-sm-1 pr-2"></div>
                      </div>
                      <div class="row">
                        <div class="col-sm-7">Seats</div>
                        <div class="col-sm-4 pl-0 txtRt pr-2">{{ roundConfirmBookingPrice(priceDetails.seatCharge) }}
                        </div>
                        <div class="col-sm-1 pr-2"></div>
                      </div>
                      <div class="row">
                        <div class="col-sm-8">Services <span class="includeServices">(Meals/Bags/Climate Product)</span></div>
                        <div class="col-sm-3 pl-0 txtRt pr-2">{{ roundConfirmBookingPrice(priceDetails.bagPrice) }}
                        </div>
                        <div class="col-sm-1 pr-2"></div>
                      </div>
                      <div class="row">
                        <div class="col-sm-7">Card Fee</div>
                        <div class="col-sm-4 txtRt pl-0 pr-2">{{ roundConfirmBookingPrice(selectedCardSurcharge || 0) }}</div>
                        <div class="col-sm-1 pr-2"></div>
                      </div>

                      <div class="row">
                        <div class="col-sm-2"><b>Total</b></div>
                        <div class="col-sm-9 pl-0 pr-0">
                          <div class="flPrice txtRt">{{ roundConfirmBookingPrice(priceDetails.totalPrice) }}</div>
                        </div>
                        <div class="col-sm-1 pull-right pl-0 pr-2">
                          <span class="smcur"> {{ priceDetails.currency}} </span>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-20">
                      <div class="col-12">
                        <button *ngIf="(isPaymentModeSelected() && isSMEUser) || (isPaymentModeSelected() && !isSMEUser)" role="button" class="ba-btn ba-btn-thin float-right book">
                          <i class="fa fa-shopping-cart"></i> Book
                        </button>
                        <button *ngIf="!isPaymentModeSelected() || isSMEUser" class="ba-btn ba-btn-thin float-right book" disabled><i class="fa fa-shopping-cart"></i> Book</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="confirmBookingFormType === 'post-booking-requote-ticket-form' || confirmBookingFormType === 'post-booking-reshop-hold'">
          <div class="row mt-20">
            <div class="col-12">
              <button *ngIf="isSMEUser || !isSMEUser" role="button" class="ba-btn ba-btn-thin float-right book"><i class="fa fa-save"></i> HOLD</button>
            </div>
            <div class="col-12">
              <button *ngIf="isSMEUser" class="ba-btn ba-btn-thin float-right book" disabled><i class="fa fa-save"></i> HOLD</button>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="confirmBookingFormType === 'post-booking-reshop-no-payment'">
          <div class="row mt-20">
            <div class="col-12">
              <button role="button" class="ba-btn ba-btn-thin float-right book" [disabled]="isSMEUser"><i class="fa fa-shopping-cart"></i> Book</button>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="confirmBookingFormType === 'post-booking-add-free-ancilliaries-service'">
          <div class="row mt-20">
            <div class="col-12">
              <button role="button" class="ba-btn ba-btn-thin float-right book"><i class="fa fa-save"></i>
                CHECKOUT</button>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="confirmBookingFormType === 'post-booking-free-sale-seat-form'">
          <div class="row mt-20">
            <div class="col-12">
              <button role="button" class="ba-btn ba-btn-thin float-right book"><i class="fa fa-shopping-cart"></i>
                Confirm Seats</button>
            </div>
          </div>
        </ng-template>
      </form>
    </div>
  </div>
</div>